import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled.ul`
  --item-gap: ${rem(8)};
  margin: 0;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--item-gap);
  list-style: none;

  > li:not(:last-child)::after {
    content: "•";
    font-size: 0.875rem;
    margin-inline-start: var(--item-gap);
  }

  &:empty {
    display: none;
  }
`

interface Props extends PropsWithChildren {
}

/**
 * Renders an inline list of bulleted items.
 *
 * _NOTE: Children should be `<li>` elements._
 *
 * @example
 * <InlineBulletList>
 *   <BodyText variant="medium" as="li">Item</BodyText>
 * </InlineBulletList>
 */
function InlineBulletList(props: Props) {
  const { children } = props

  return <Container>
    {children}
  </Container>
}

export default InlineBulletList
